module.exports = __webpack_public_path__ + "images/down-arrow-pc_7e7d7dc661597249bb55fdbc64c0c65e.png";